import { planTypes } from '@/common/constants';

/**
 * Get effective amount for plan based on downsell conditions
 * @param {Object} plan - The plan object
 * @param {Object} context - Context object containing edit information
 * @returns {number} - The effective amount to use for price calculation
 */
export function getEffectiveAmount(plan, context = {}) {
  // Only apply downsell logic in edit flow
  if (!window.$context?.is?.edit) {
    return plan.amount;
  }

  // Only apply to LARGE_MEETING and WEBINAR
  if (![planTypes.LARGE_MEETING, planTypes.WEBINAR, planTypes.ZOOM_CUSTOM_AI_COMPANION].includes(plan.type)) {
    return plan.amount;
  }

  // Check if this plan has downsell amount overwrite capability
  if (!plan.isDownsellAmountOverwrite || !plan.downsellAmount) {
    return plan.amount;
  }

  // Get current license count from multiple sources
  let currentLicense = context.currentLicense || 0;
  
  // If no context provided, try to get from global sources
  if (!currentLicense && typeof window !== 'undefined') {
    // Try currentEditPlan first
    currentLicense = window.$context?.currentEditPlan?.cartInfo?.selected_number;
    
    // If still no license, try from boughtPlans
    if (!currentLicense) {
      const boughtPlan = window.$context?.boughtPlans?.find(bp => bp.plan_code === plan.plan_code || bp.type === plan.type);
      currentLicense = boughtPlan?.cartInfo?.selected_number;
    }
    
    // If still no license, try from store
    if (!currentLicense && window.$store) {
      const storedBoughtPlans = window.$store.getters.boughtPlans || [];
      const storedBoughtPlan = storedBoughtPlans.find(bp => bp.plan_code === plan.plan_code || bp.type === plan.type);
      currentLicense = storedBoughtPlan?.cartInfo?.selected_number;
    }
  }
  
  currentLicense = currentLicense || 0;
  
  // Get new license count from plan's cart info
  const newLicense = plan.cartInfo?.selected_number || 0;

  // If license is decreasing, use downsell amount
  if (newLicense < currentLicense && newLicense > 0) {
    return plan.downsellAmount;
  }

  return plan.amount;
}
